<template>
    <v-dialog
            v-model="valueRelay"
            :persistent="true"
            width="600"
    >
        <v-card max-width="600">
            <v-progress-linear
                    v-if="loading"
                    color="primary"
                    indeterminate
            ></v-progress-linear>
            <v-card-title class="text-h5">
                Two Factor Setup
            </v-card-title>

            <v-card-text>
                <div class="d-flex align-center">
                    <div class="d-flex align-center justify-center">
                        <img ref="qr" alt="QR Code"/>
                    </div>
                    <div class="justify-center px-3">
                        Please use the QR Code to add TOTP Authentication using you favorite app
                        <br>
                        <br>
                        Take note of your recovery key. Please save this key, you will need it to reactivate you account
                        in the event of not being able to use your device
                    </div>
                </div>
                <div class="text-caption d-flex align-center">

                    <div class="flex-grow-1 py-2">
                        Recovery Key:
                        <br>
                        {{ recoveryKey }}
                    </div>
                    <v-btn
                            class="mx-2"
                            color="primary"
                            size="x-small"
                            text
                            @click="copyRecoveryKey()"
                    >
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </div>

            </v-card-text>

            <v-card-actions>
                <v-text-field
                        prepend-inner-icon="mdi-lock-clock"
                        v-model="totpCode"
                        label="Verify OTP"
                        placeholder="eg. 156789"
                        hide-details
                        variant="outlined"
                        clearable
                        clear-icon="mdi-cancel"
                        density="compact"
                        @keydown.enter="verify"
                        :disabled="loading"
                ></v-text-field>
                <v-btn
                        variant="contained-text"
                        class="ml-2"
                        color="secondary"
                        @click="verify"
                        :disabled="loading"
                >
                    Verify
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import QRCode from 'qrcode'
import {copyText} from "@/core/codeFunctions";

export default {
    components: {},
    data: () => {
        return {
            totpCode: null,
            loading: false
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        uri: String,
        recoveryKey: String,
        username: String
    },
    mounted() {

        this.genQRRun();
    },
    methods: {
        async verify() {

            if (this.totpCode && this.totpCode.split('').length !== 6)
                return this.$snack.error('TOTP code must be 6 characters long')

            try {
                this.loading = true;
                const verified = await this.$newReq('POST', `login/verifyTotp`, {
                    username: this.username,
                    recoveryKey: this.recoveryKey,
                    totpCode: this.totpCode
                })
                if (verified)
                    this.$emit('verified', this.totpCode);
            } catch (e) {
                console.log(e)
                if (e.response && e.response.status === 401)
                    this.$snack.error(e.response.data)
                else
                    this.$snack.netWorkError();

            } finally {
                this.loading = false;
            }
        },

        copyRecoveryKey() {
            copyText(document, this.recoveryKey);
            this.$snack.info('Copied To Clipboard');
        },

        genQRRun() {
            setTimeout(() => {
                if (this.$refs && this.$refs.qr)
                    this.genQR();
                else
                    this.genQRRun();
            }, 100)
        },

        genQR() {
            let opts = {
                errorCorrectionLevel: 'L',
                type: 'image/jpeg',
                quality: 0.1,
                margin: 1,
                color: {
                    dark: "#000000",
                    light: "#ffffff"
                },
                width: 180
            }

            const vm = this
            QRCode.toDataURL(this.uri, opts, function (err, url) {
                if (err) throw err

                let img = vm.$refs.qr
                img.src = url
            })
        }

    },
    computed: {
        valueRelay: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>

<style scoped>

</style>